import { Children, ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './TagsGroup.module.css';

type Props = {
  children: ReactNode;
  color?: 'active' | 'active-faded' | 'gray';
  className?: string;
};

export function TagsGroup({ children, color = 'active', className }: Props) {
  const childArray = Children.toArray(children);

  return (
    <div className={cx(styles.root, styles[`color_${color}`], className)}>
      {childArray.map((child, idx) => (
        <div key={idx} className={styles.tag}>
          {child}
        </div>
      ))}
    </div>
  );
}
